export default __webpack_public_path__ + "static/media/powered_by_tulka.76f3ef5e.png";